const feetToCm = (ft: number): number => {
  return Math.round(ft * 30.48);
};

export default feetToCm;
